import React from 'react';

import { PrivateArchivalUnit } from 'types';
import { PageKey, SortOrder } from 'enums';

import { LentTable } from '../lent-table';
import { fetchTableItems } from '../lent-api';
import { lentDigitalColumns } from '../lent-columns';

const fetchFunction = fetchTableItems<PrivateArchivalUnit>(
  '/api/archival-unit/private/my-copies'
);

export function LentTableDigitalArchivalUnits() {
  return (
    <>
      <LentTable<PrivateArchivalUnit>
        title="Zpřístupněné digitální archiválie"
        pageKey={PageKey.PORTFOLIO_LENT_DIGITAL}
        columns={lentDigitalColumns}
        fetchFunction={fetchFunction}
        params={{
          sort: [
            { field: 'archivalUnitReference.numericId', order: SortOrder.ASC },
          ],
        }}
      />
    </>
  );
}
